import { NgModule } from '@angular/core';
import { ContenteditableModelDirective } from './contenteditable-model.directive';

@NgModule({
    declarations: [ContenteditableModelDirective],
    exports: [ContenteditableModelDirective],
})
export class FiContenteditableModelModule {}
